
import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { FilterPipe as CustomFilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import Swal from 'sweetalert2';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

// Removed: import { BusinessEmployeeComponent } from '../business-employee/business-employee.component'; - component should not be imported for injection

@Component({
  selector: 'app-business-admin',
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TruncatePipe,
    CustomFilterPipe,
UserCardComponent,
    CommonSkeletonComponent,
    NodataFoundComponent,
    AutocompleteLibModule,
    // Add Admin uses ng-select (same control as the Job Center Transfer picker);
    // the other dialogs in this file still use AutocompleteLibModule.
    NgSelectModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './business-admin.component.html',
  styleUrls: ['./business-admin.component.scss'],
  // Default (Emulated) encapsulation on purpose. This component used to be
  // ViewEncapsulation.None, which injected this file's generic class names
  // (.btn-group, .img-circle, .ellipse, .item, .card, .right, ...) into <head>
  // as a GLOBAL sheet that Angular never removed, so visiting Page Admin once
  // misaligned user cards across the rest of the app for the session.
})
export class BusinessAdminComponent implements OnInit, OnDestroy {
  /** Wireframe list header (title + count, full-width search pill); false = old Bnav header. */
  useWireframeHeader = true;
  @Input() commonemit
  @ViewChild('filterDropdown', { static: false }) filterDropdown!: BsDropdownDirective;
  businessId: any
  userId: any
  adminSearchForm!: UntypedFormGroup
  values = { businessId: "", admin: false, menu: "", userId: "", adminType: "", admindata: [], employees: [], tempAdmindata: [] }
  // values: any = {}
  transferId: any;
  addAdminId: any;
  emptyspace = "             "
  adminType: any
  modalRef!: BsModalRef;
  planType: any = localStorage.getItem('MemberShipType');
  clickEventsubscription!: Subscription;
  businessDetail: any
  adminList: any = [];
  autoCompleteAdminList: any = [];
  nonAdminList: any = []
  employeeList: any = []
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    // class: 'modal-md'
  }
  tempAdmindata: any;
  noDatafound: Array<string> = ["No Data to Display"]
  showNoDatafound: boolean = false;
  name
  serachForm: UntypedFormGroup;
  keyword = 'userName';
  item: any;
  admin_data_pop_up
  adminName
  removeAdmin_userid
  superAdmin_userid
  // isAdmin
  // isSuperAdmin
  // superadminflag: Boolean = false;
  colors: Array<any> = ['hgreen', 'hred', 'horange', 'hyellow'];
  selColor: string;
  loginUserId = localStorage.getItem('userId');
  // Wireframe cards (2-up, like Employees/Followers). false = previous 3-up cards.
  useWireframeCards = true;
  userCardConfig: UserCardConfig[] = []
  searchKey

  // Mirrors business-employee: the search box and the ADMIN/SUPERADMIN dropdown
  // both drive one server-side payload rather than filtering an in-memory list.
  adminPayload = {
    businessId: null,
    searchText: null,
    adminType: null
  };
  searchSubject = new Subject<string>();
  // false while a load/search/filter call is in flight; drives the skeleton cards
  responseReceived: boolean = false;

  constructor(
    private util: UtilService,
    private api: ApiService,
    // private commonvalues: CommonValues,
    private _activated_route: ActivatedRoute,
    // Removed: private employees: BusinessEmployeeComponent - component should not be injected as service
    private router: Router,
    private modalService: BsModalService,
    private JobServicecolor: JobService,
    private fb: UntypedFormBuilder) {
    this._activated_route.queryParams.subscribe(res => {
      this.businessData = res
    })
    // this.commonvalues.getbusinessid().subscribe((res) => {

    //   this.values = res

    // })
    this.randomColor();

  }

  randomColor(): void {
    this.selColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  businessData: any;
  ngOnInit() {

    // this.isAdmin = localStorage.getItem('isAdmin');
    // this.isSuperAdmin = localStorage.getItem('isSuperAdmin');

    // if (this.isSuperAdmin) {
    //   this.isAdmin = this.isSuperAdmin
    // }
    this.userId = localStorage.getItem('userId')
    this.businessDetails()

    this.adminSearchForm = this.fb.group({
      chooseAdmin: [null, [Validators.required]]
    })

    let revokeBtn: UserCardConfig = new UserCardConfig("Connect", this.removedata, this.canShow, true);
    revokeBtn.source = this;
    this.userCardConfig.push(revokeBtn);

    this.values = this.commonemit
    this.formserchData()
    this.employeesquaryapicall()
    this.getAdmins(this.businessData.businessId)

    // Debounce the search box so typing "rina" is one request, not four. Same
    // shape as business-employee's searchSubject.
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(val => {
      this.adminPayload.searchText = val && val.trim() ? val.trim() : null;
      this.loadAdminListing();
    });
    // console.log(this.values)
  }

  // Emit into the debounced stream; the subscription above does the call.
  onSearchAdmin(val: string) {
    this.searchSubject.next(val);
  }

  // Server-side search + ADMIN/SUPERADMIN filter. Only adminListing is replaced -
  // adminList and autoCompleteAdminList stay as the full set that getAdmins loaded,
  // because the transfer-admin picker needs every admin, not the filtered ones.
  loadAdminListing() {
    this.adminPayload.businessId = this.businessData?.businessId ?? null;
    // Skeleton cards rather than util.startLoader(): a blocking overlay on every
    // keystroke-debounce makes the page feel frozen while typing.
    this.responseReceived = false;
    this.api.create('business/admins', this.adminPayload).subscribe(response => {
      const rows = (response?.data?.businessAdminList || []).map(element => this.mapAdminRow(element));
      this.adminListing = rows;
      this.responseReceived = true;
    }, err => {
      this.adminListing = [];
      this.responseReceived = true;
    });
  }



  canShow(data, source): boolean {
    return false;
  }

  removedata(data) {
    //// console.log(data)

  }


  ngAfterViewInit(): void {
    // setInterval(() => {
    //   this.isSuperAdmin = localStorage.getItem('isSuperAdmin');
    //   if (this.isSuperAdmin === "true") {
    //     this.superadminflag = true;
    //   } else {
    //     this.superadminflag = false;
    //   }

    // }, 700);
  }



  //  select admin  datas

  formserchData() {
    this.serachForm = this.fb.group({
      serachData: [''],
    });
  }

  selectEvent(val) {
    this.addAdminId = val.userId
    // Update the form control to show the selected employee name in the input field
    this.serachForm.patchValue({
      serachData: val.userName
    });
    console.log(val)
  }

  selectEvent1(val) {
    this.transferId = val.userId
    // Update the form control to show the selected employee name in the input field
    this.serachForm.patchValue({
      serachData: val.userName
    });
  }

  onFocused1(event) {

  }

  updateQueryParams(id) {
    const datas: any = {};
    datas.businessId = this.businessData.businessId;
    datas.userId = localStorage.getItem("userId");
    this.util.startLoader();
    this.api.create("business/check/admin", datas).subscribe((res) => {
      this.util.stopLoader();
      const mergedParams = { ...res, ... datas};
      const urlPath ='/business/post';
       this.router.navigate([urlPath], {
        queryParams: mergedParams,
      });
    });
  }


  makeadmin() {

    if (this.superAdmin_userid != undefined && this.superAdmin_userid != null) {
      let data = {
        "businessId": this.businessData.businessId,
        "userId": this.superAdmin_userid,
        "adminType": "SUPERADMIN"
      }
      this.util.startLoader()
      this.api.create('business/add/admin', data).subscribe(res => {
        this.util.stopLoader()
        if (res.code == "00000") {
          this.decline();
         localStorage.setItem('isSuperAdmin', 'false')
         this.updateQueryParams(this.businessData.businessId);
          // window.location.reload()
          // this.getAdmins(this.businessData.businessId)
        } else if (res.code == "99999") {

        }
      }, err => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Something went wrong while adding admin. Please, try again later.',
            showDenyButton: false,
            confirmButtonText: `ok`,
          })
        }
      })
    }
  }


  makeSuperadmin() {
    if (this.transferId != undefined && this.transferId != null) {

      let data = {
        "businessId": this.businessData.businessId,
        "userId": this.transferId,
        "adminType": "SUPERADMIN"
      }
      this.util.startLoader()
      this.api.create('business/add/admin', data).subscribe(res => {
        this.util.stopLoader()
        if (res.code == "00000") {
          this.decline()
          // window.location.reload()
          localStorage.setItem('isSuperAdmin', 'false')
          this.updateQueryParams(this.businessData.businessId);
        } else if (res.code == "99999") {

        }
      }, err => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Something went wrong while transferring super-admin rights. Please, try again later.',
            showDenyButton: false,
            confirmButtonText: `ok`,
          })
        }
      })
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select admin',
        //showConfirmButton: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 3000
      })
    }
  }


  cleardata(data) {
    this.addAdminId = null;
    this.transferId = null;
  }




  // add  admin api call here

  addAdmin() {

    if (this.addAdminId != undefined && this.addAdminId != null) {
      let data = {
        "businessId": this.businessData.businessId,
        "userId": this.addAdminId,
        "adminType": "ADMIN"
      }

      this.util.startLoader()
      this.api.create('business/add/admin', data).subscribe(res => {
        this.util.stopLoader()
        if (res.code == "00000") {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Admin added successfully.',
            // text: "Admin added successfully.",
            //showConfirmButton: true,
            allowOutsideClick: false,
            showConfirmButton: false,
            timer: 3000
          }).then(() => {
            this.getAdmins(this.businessData.businessId);
          })

          // this.commonvalues.getbusinessid()
          this.modalRef.hide()
          // this.decline()

        } else {
          this.decline()
          this.getAdmins(this.businessData.businessId)

        }
      }, err => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Something went wrong while adding admin. Please, try again later.',
            showDenyButton: false,
            confirmButtonText: `ok`,
          })
        }
      })

    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an employee',
        //showConfirmButton: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 3000
      })
    }

  }



  onChangeSearch(val: string) {
    // Handle search input changes
  }

  onFocused(e) {
    // this.item=e
    // this.admin_data_pop_up=e
  }

  decline(): void {
    this.addAdminId = null;
    this.transferId = null;
    this.modalRef.hide();
    this.serachForm.reset();

  }


  close() {
    this.addAdminId = null;
    this.transferId = null;
    this.modalRef.hide();
    this.serachForm.reset();

  }
  businessDetails() {
    let datas: any = {};
    datas.userId = localStorage.getItem('userId')
    this.util.startLoader()
    this.api.create("business/check/user", datas).subscribe(res => {
      this.util.stopLoader()
      this.businessDetail = res.data.businessModelList[0];
    }, err => {
      this.util.stopLoader();

    });
  }

  openModal(template: TemplateRef<any>) {
    // this.employeesList.next([]);
    // this.employeeStopScroll = false;
    // this.employeePrevSearchAfterKey = null;
    // this.userPayload.searchAfterKey = null;
    // this.userPayload.searchContent = null;
    this.employeesquaryapicall()
    this.formserchData();
    // Every open starts from a clean selection, alongside formserchData()
    // rebuilding the form above.
    //
    // Needed because addAdmin()'s success branch only calls modalRef.hide(); it
    // leaves addAdminId set (the failure branch goes through decline(), which
    // clears it). On the next open, employeesquaryapicall() empties
    // employeeList and refills it, and the person just promoted is no longer in
    // connectedemployees — so ng-select held a bindValue it could not resolve to
    // an item and drew a chip with an empty label and a bare ✕.
    this.addAdminId = null;
    // `gs-add-admin-modal` is the styling hook for this dialog's alignment rules
    // (styles.scss). ngx-bootstrap puts config.class on .modal-dialog, so the
    // selector exists only while THIS dialog is open — every other modal in the
    // component keeps `backdropConfig` untouched.
    this.modalRef = this.modalService.show(template, {
      ...this.backdropConfig,
      class: 'gs-add-admin-modal',
    });
  }





  employeesquaryapicall() {
    this.employeeList = []
    let datas: any = {};
    datas.businessId = this.businessData.businessId;
    this.util.startLoader()
    this.api.create('business/connectedemployees', datas).subscribe(res => {
      this.employeequary(this.employeeList);
      if (res && res != null && res.length === 0) {
        this.util.stopLoader();
      }

      res.forEach(element => {
        // if (element.userId != 'undefined' || element.userId != 'null' || element.userId != '') {
        // this.api.query('user/connection/' + element.userId).subscribe(res => {
        this.util.stopLoader();
        // var photos
        // if (element.photo == null) {
        //   photos = "assets/images/userAvatar.png"
        // } else if (element.photo != null) {
        //   photos = AppSettings.photoUrl + element.photo;
        // }
        this.employeeList.push({
          userName: element.fullName,
          fullName: element.fullName,
          lastName: element.lastName,
          firstName: element.firstName,
          // photo: photos,
          photo: element.photo,
          organisation: element.organisation,
          title: element.title,
          status: element.status,
          userId: element.userId,
          type: element.type,
          connected: element.connected,

        })
        this.employeequary(this.employeeList)
        //   })
        // }





      })

      // Hand ng-select a NEW array reference. The loop above push()es into the
      // existing one, so the reference never changes; ng-select reads `items`
      // through ngOnChanges, which only fires on a reference change, so it kept
      // showing the empty list it was given at open time ("No employee found").
      // Same reason getAdmins() accumulates locally and assigns once.
      this.employeeList = [...this.employeeList];
    }, err => {
      this.util.stopLoader();

    });
  }


  employeequary(datas) {
    this.employeeList = datas
    // this.values.employees = this.employeeList
    // this.commonvalues.businessid(this.values);
  }

  transferModal(template: TemplateRef<any>) {
    // this.employees.employees()
    this.formserchData()
    // this.autoCompleteAdminList = [];
    this.modalRef = this.modalService.show(template, this.backdropConfig);
    this.getAdmins(this.businessData.businessId)
  }

  photoUrl: string = AppSettings.photoUrl;
  getAdmins(bussinessid) {
    this.adminList = [];
    this.adminListing = []
    this.autoCompleteAdminList = [];
    let data = {
      "businessId": bussinessid,
      "userId": this.userId
    }
    // this.adminquary(this.adminList)
    // setTimeout(() => {
    this.responseReceived = false;
    this.api.create('business/admins', data).subscribe(respose => {
      // Accumulate locally and assign once below. Pushing into this.adminListing
      // leaves the array reference unchanged, which stops Angular re-rendering.
      const rows = [];
      const autoComplete = [];
      (respose?.data?.businessAdminList || []).forEach(element => {
        if (element.userId) {
          const d = this.mapAdminRow(element);
          rows.push(d);

          if (
            this.userId !== element.userId &&
            (this.planType === 'Free' ||
            ((this.planType === 'ScaleX' || this.planType === 'Growth' || this.planType === 'ScaleX') && element.userType === 'MANAGEMENT_TALENT_ACQUISITION'))
          ) {
            autoComplete.push(d);
          }
        }
      })

      this.adminList = rows;
      this.adminListing = [...rows];
      this.tempAdmindata = this.adminList;
      this.autoCompleteAdminList = autoComplete;
      this.responseReceived = true;
    }, err => {
      this.responseReceived = true;
    });
  }

  // Shared row shape for both the full load and the search/filter load.
  mapAdminRow(element) {
    if (element.admin == true) {
      element.assignedOn = new Date();
    }
    const color = this.colors[Math.floor(Math.random() * this.colors.length)];

    // The person's details sit at the top level of the row, but older server
    // builds only nested them under userData. Fall back so userName never ends up
    // as the string "undefined undefined".
    const firstName = element.firstName || element.userData?.firstName || '';
    const lastName = element.lastName || element.userData?.lastName || '';
    const fullName = (element.fullName || element.userData?.fullName || (firstName + ' ' + lastName)).trim();

    return {
      fullName: fullName,
      userName: fullName,
      lastName: lastName,
      firstName: firstName,
      postCnt: element.postCnt,
      connectionCnt: element.connectionCnt,
      jobsCount: element.jobsCount,
      candidatesCount: element.candidatesCount,
      photo: element.photo || element.userData?.photo,
      organisation: element.organisation || element.userData?.organisation,
      title: element.title || element.userData?.title,
      connectionStatus: element.connectionStatus,
      status: element.status,
      userId: element.userId,
      assignedOn: element.assignedOn,
      type: element.type,
      connected: element.connected,
      userType: element.userType,
      colorVal: color,
      index: this.userId === element.userId ? 1 : 2
    };
  }

  filterName: string = "All";
  adminFilter(val) {
    // Goes through the same payload as the search box so the two compose: filtering
    // to SUPERADMIN while "rina" is typed asks the server for superadmins named rina.
    this.adminPayload.adminType = (val === "ALL") ? null : val;
    this.loadAdminListing();

    let [first, ...rest] = val;
    this.filterName = first + rest.join("").toLowerCase();
    
    // Close the dropdown after selection
    if (this.filterDropdown) {
      this.filterDropdown.hide();
    }
  }
  getInitials(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  getColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  adminListing: any = []

  adminquary(datas) {
    ////// console.log(datas);
    this.adminList = this.sortData(datas);
    // this.values.menu = 'pageadmin'
    this.adminListing = this.adminList.sort(this.dynamicSort("userName"));
    this.adminListing.forEach((element, i) => {
      if (element.userId == localStorage.getItem("userId")) {
        var b = this.adminListing[i];
        this.adminListing[i] = this.adminListing[0];
        this.adminListing[0] = b;
      }
      this.values.tempAdmindata = this.adminListing;
      this.tempAdmindata = this.adminListing;
      // this.commonvalues.businessid(this.values);

    });

    // this.commonvalues.businessid(this.values);

  }
  onsearch(val) {
    if (val != undefined) {
      val = val.trim().toLowerCase();
    }

    var datapass = [];
    datapass = this.tempAdmindata;
    this.adminListing = this.tempAdmindata;
    // this.commonvalues.businessid(this.values);

    //// console.log(datapass)
    let admindata = this.filterByString(datapass, val);
    this.adminListing = admindata;
    // this.commonvalues.businessid(this.values);

    if (this.adminListing.length == 0) {
      this.showNoDatafound = true;
    } else {
      this.showNoDatafound = false;
    }

  }

  keyupdata(event) {
    if (event.target.value.length == 0) {
      this.onsearch('');
    }
  }

  filterByString(data, s) {
    return data.filter(e => e.userName.toLowerCase().includes(s))
      .sort((a, b) => a.userName.toLowerCase().includes(s) && !b.userName.toLowerCase().includes(s) ? -1 : b.userName.toLowerCase().includes(s) && !a.userName.toLowerCase().includes(s) ? 1 : 0);
  }
  sortData(data) {
    return data.sort((a, b) => {
      return <any>new Date(b.assignedOn) - <any>new Date(a.assignedOn);
    });
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }



  revoke(template: TemplateRef<any>, userId) {
    // this.employees.employees()
    this.removeAdmin_userid = userId
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  superAdmin(template: TemplateRef<any>, data) {

    this.superAdmin_userid = data
    this.autoCompleteAdminList = [];
    this.getAdmins(this.businessData.businessId)
    // this.employees.employees()
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }


  // reloadpage() {

  //   let data: any = {}
  //   data.commonemit.businessId = this.businessData.businessId
  //   data.commonemit.businessName = this.values.businessName
  //   data.commonemit.commondata.menu = "pageadmin"

  //   this.router.navigate(['business'], { queryParams: data })
  //   setTimeout(() => {
  //     this.router.navigate(['business'], { queryParams: data })
  //     window.location.reload();
  //   }, 400);


  // }

  // Dropdown auto-close on scroll - similar to business-post component
  private dropdownScrollHandler: (() => void) | null = null;

  bindDropdownAutoClose(dropdown: { hide: () => void }): void {
    this.unbindDropdownAutoClose();
    this.dropdownScrollHandler = () => dropdown.hide();
    window.addEventListener('scroll', this.dropdownScrollHandler, true);
  }

  unbindDropdownAutoClose(): void {
    if (this.dropdownScrollHandler) {
      window.removeEventListener('scroll', this.dropdownScrollHandler, true);
      this.dropdownScrollHandler = null;
    }
  }

  ngOnDestroy(): void {
    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
    this.searchSubject.unsubscribe();
    this.unbindDropdownAutoClose();
  }


  //   removeAdmin api call here

  removeAdmin() {
    let data = {
      "businessId": this.businessData.businessId,
      "userId": this.removeAdmin_userid
    }
    this.util.startLoader()
    this.api.create('business/remove/admin', data).subscribe(res => {
      this.util.stopLoader()
      ////// console.log(res)
      if (res) {
        if (res.code === '00000') {
          this.getAdmins(this.businessData.businessId);
          this.modalRef.hide();
        }
      }
      this.businessDetails()

      //this.adminList=res;
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while removing admin. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }



  sendmsg(data) {
    var userData: any = {}
    userData.groupId = data.userId;
    userData.type = "USER";
    this.router.navigate(['message'], { queryParams: userData })
  }

  userprofile(data) {
    var userData: any = {}
    userData.userId = data
    this.router.navigate(['personalProfile'], { queryParams: userData })
  }

}

